module.exports = __webpack_public_path__ + "static/media/hugo-boss-bottled-big.95528d3d.png";